import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import { ITEMS_SELECTION_WITH_MODIFIERS } from '../../containers/OrderHelpTemplateContainer/templateTypes';

import ModalFooter from '../ModalFooter';
import OrderHelpItemsSelection from '../OrderHelpItemsSelection';

/**
 * A generic dynamic actions template to render a list of checkable order items and action on them.
 */
class OrderHelpTemplateItemsSelectionWithModifiers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submittingIssue: false,
      selectedItems: [],
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.onItemsSelection = this.onItemsSelection.bind(this);
  }

  onSubmit() {
    this.setState({
      submittingIssue: true,
    });

    const { orderId, actionId, requestInteraction } = this.props;

    const formattedSelectedItems = this.state.selectedItems.map((item) => ({
      order_item_id: item.orderItemId,
      include_main_item: item.includeMainItem,
      modifiers: item.modifiers.map((modifier) => ({
        order_item_id: modifier.orderItemId,
      })),
    }));

    requestInteraction({
      parentActionId: actionId,
      parentActionTemplate: ITEMS_SELECTION_WITH_MODIFIERS,
      templateData: {
        order_id: orderId,
        order_items: formattedSelectedItems,
      },
    });
  }

  onItemsSelection(items) {
    this.setState({
      selectedItems: items,
    });
  }

  render() {
    const {
      iframe,
      data: { orderItems },
      hideFooterPrevious,
    } = this.props;

    return (
      <Fragment>
        <OrderHelpItemsSelection
          items={orderItems}
          onItemsSelection={this.onItemsSelection}
          iframe={iframe}
        />

        <ModalFooter
          onSubmit={this.onSubmit}
          isLoading={this.state.submittingIssue}
          disabled={this.state.selectedItems.length === 0}
          modal={iframe}
          cta="Submit"
          hidePrevious={hideFooterPrevious}
        />
      </Fragment>
    );
  }
}

OrderHelpTemplateItemsSelectionWithModifiers.propTypes = {
  /**
   * Whether to style the template appropriately for a modal.
   */
  iframe: PropTypes.bool.isRequired,
  /**
   * The ID of the current order, used for the updateInteraction.
   */
  orderId: PropTypes.string.isRequired,
  /**
   * Which help screen the template is currently on.
   */
  actionId: PropTypes.string.isRequired,
  /**
   * Template data to fill out the generic template.
   */
  // eslint-disable-next-line react/require-default-props
  data: PropTypes.shape({
    orderItems: PropTypes.array.isRequired,
  }).isRequired,
  /**
   * Whether to hide the previous button for the footer
   */
  hideFooterPrevious: PropTypes.bool,
  /**
   * The dispatch action that will be triggered onClick for each OrderHelpActionRows.
   * This will be used to update the dynamic action and grab the next self help page
   */
  requestInteraction: PropTypes.func.isRequired,
};

OrderHelpTemplateItemsSelectionWithModifiers.defaultProps = {
  // eslint-disable-next-line react/default-props-match-prop-types
  data: {},
  hideFooterPrevious: true,
};

export default OrderHelpTemplateItemsSelectionWithModifiers;
